module.exports = __webpack_public_path__ + "img/web-about-principles-values.d2a2e87d.png";